import { query, mutate } from '~services/apollo'
import { getAllOnboardingStepsQuery, getOnboardingProgressQuery, markOnboardingStepCompleteMutation } from '~src/graphql/onboarding.graphql'
import store from '@/store/store'

// Types
export interface OnboardingStep {
  id: string
  key: string
  title: string
  description: string | null
  category: string
  route: string | null
  uiOrder: number
  icon: string | null
  tutorialUrl: string | null
  isActive: boolean
  isProjectRoute: boolean
}

export interface OnboardingProgress {
  id: string
  stepKey: string
  completedAt: string
  createdBy: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata: Record<string, unknown> | null
}

// Buscar todas as etapas de onboarding
export const getOnboardingSteps = async (): Promise<OnboardingStep[]> => {
  return query({
    query: getAllOnboardingStepsQuery,
    fetchPolicy: 'no-cache',
    loadingKey: 'onboarding:steps:get'
  }).then(response => {
    return response.data.onboardingSteps?.nodes || []
  })
}

// Buscar progresso do onboarding da organizacao atual
export const getOnboardingProgress = async (): Promise<OnboardingProgress[]> => {
  return query({
    query: getOnboardingProgressQuery,
    fetchPolicy: 'no-cache',
    loadingKey: 'onboarding:progress:get'
  }).then(response => {
    return response.data.onboardingProgresses?.nodes || []
  })
}

// Marcar etapa como completa
export const markStepComplete = async (stepKey: string): Promise<OnboardingProgress | null> => {
  // Verificar se ja foi completada no store
  const state = store.state.onboardingModule
  const alreadyComplete = state?.progress?.find((p: OnboardingProgress) => p.stepKey === stepKey)
  if (alreadyComplete) {
    return alreadyComplete
  }

  return mutate({
    mutation: markOnboardingStepCompleteMutation,
    variables: { pStepKey: stepKey },
    loadingKey: 'onboarding:step:complete'
  }).then(response => {
    const result = response.data?.markOnboardingStepComplete?.onboardingProgress || null

    // Atualizar o Vuex store para que a UI reflita a mudanca
    if (result) {
      store.commit('onboardingModule/ADD_PROGRESS', result)
      store.dispatch('onboardingModule/checkIfComplete')
    }

    return result
  })
}
